export const blockIconsToggleToggleOn = (
	<span className='material-symbols-outlined'>toggle_on</span>
);
